import { Container } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import RolesList from '../../../Component/Application/Roles/RolesList';
import { useTranslation } from 'react-i18next';

const RolesManagement = () => {
  const { t } = useTranslation();
  return (
    <div className="page-body">
      <Breadcrumbs mainTitle={t('Gestión de Roles')} parent={t('Administración')} />
      <Container fluid>
        <RolesList />
      </Container>
    </div>
  );
};

export default RolesManagement;

